module.exports = __webpack_public_path__ + "static/img/fn57.293f9f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/images/fn57.png
// module id = 3rEX
// module chunks = 0